import { chakraStyled } from 'utils';

import { Text } from '@chakra-ui/react';

export const Label = chakraStyled(Text, {
  fontSize: '16px',
  textAlign: 'left',
});
